import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
  makeStyles,
} from "@fluentui/react-components";
import { ArrowSyncFilled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { ButtonWithLoading } from "../ButtonWithLoading";
import { useApiNavigationCache } from "../../hooks/useApiCache";
import { useState } from "react";

const useStyles = makeStyles({
  confirmButton: {
    width: "fit-content",
    gap: "8px",
  },
});

export const RecacheNavigationButtonDialog = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const { mutateAsync: recacheNavigation, isPending } = useApiNavigationCache();

  const submitRecacheNavigation = async () => {
    try {
      await recacheNavigation();
      setOpen(false);
    } catch (error) {
      setOpen(false);
      console.warn("Recaching navigation failed:", error);
    }
  };

  return (
    <Dialog modalType="alert" open={open}>
      <DialogTrigger disableButtonEnhancement>
        <Button
          size="large"
          appearance="primary"
          className={classes.confirmButton}
          onClick={() => setOpen(true)}
        >
          <ArrowSyncFilled />
          <span>{t("recacheNavigation")}</span>
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("recacheNavigation")}</DialogTitle>
          <DialogContent>{t("recacheNavigationPrompt")}</DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" onClick={() => setOpen(false)}>
                {t("cancel")}
              </Button>
            </DialogTrigger>

            <ButtonWithLoading
              onClick={submitRecacheNavigation}
              isLoading={isPending}
              text={t("recacheNavigation")}
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default RecacheNavigationButtonDialog;
